import { render, staticRenderFns } from "./SearchResultItemPostBody.vue?vue&type=template&id=5655c0c8&scoped=true&"
import script from "./SearchResultItemPostBody.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemPostBody.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemPostBody.vue?vue&type=style&index=0&id=5655c0c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5655c0c8",
  null
  
)

export default component.exports